import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SaveButton} from "../../business_units/SaveButton";
import {Spinner} from "../../Spinner";
import {Button, Input} from "reactstrap";
import {SpinnerSecondaryButton} from "../../SpinnerSecondaryButton";
import {HELP_GA4_THOU_SHEETS, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class AnalyticsComponentClass extends Component {
    constructor(props) {
        super(props);

        this.handleAnalyticsChange = this.handleAnalyticsChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTest = this.handleTest.bind(this);

        this.state = {
            testing: false,
            loading: true,
            isSaving: false,
            hasChanges: false,
            hasAccessToModule: null,
            analyticsUrl: null
        };
    }

    getPostData() {
        return {
            "analytics_url": this.state.analyticsUrl
        };
    }

    handleTest() {
        const { t } = this.props;
        this.setState({testing: true});
        const data = this.getPostData();

        this.testAnalyticsUrl(data).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                alert(t('analytics_component.test_success'));
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            } else if (response.status === 'CAN_NOT_ACCESS_URL') {
                alert(t('analytics_component.url_access_error'));
            } else if(response.status === "HEADERS_DONT_MATCH") {
                alert(t('analytics_component.csv_format_error'));
            }
            this.setState({testing: false});
        });
    }

    handleSubmit() {
        const { t } = this.props;
        this.setState({isSaving: true});

        this.postForm(this.getPostData()).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                alert(t('analytics_component.changes_saved'))
                this.setState({hasChanges: false});
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            }
            this.setState({isSaving: false});
        });
    }

    postForm(data) {
        const apiClient = new APIClient(this.getAnalyticsUrl());
        return apiClient.call('PUT', data);
    }

    testAnalyticsUrl(data) {
        const apiClient = new APIClient(this.getTestAnalyticsUrl());
        return apiClient.call('PUT', data);
    }

    componentDidMount() {
        this.getAgencyAnalyticsConfiguration();
    }

    getAgencyAnalyticsConfiguration() {
        new APIClient(this.getAnalyticsUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'NO_MODULE_ACCESS') {
                this.setState({hasAccessToModule: false});
            } else if (data.status === 'OK') {
                const analyticsUrl = data.data !== undefined ? data.data["analytics_url"] : null;

                this.setState({
                    analyticsUrl: analyticsUrl,
                    hasAccessToModule: true,
                    loading: false
                });
            }
        })
    }

    getAnalyticsUrl() {
        return API_URL + 'analytics/';
    }

    getTestAnalyticsUrl() {
        return API_URL + 'analytics/test';
    }

    handleAnalyticsChange(event) {
        const target = event.target;

        this.setState({
            analyticsUrl: target.value,
            hasChanges: true
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        return <SaveButton text={t('analytics_component.save_button')}
                           isSaving={this.state.isSaving}
                           onClick={this.handleSubmit}
                           hasChanges={this.state.hasChanges}/>
    }

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title">{t('analytics_component.integration_title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderNotAccessStatus() {
        const { t } = this.props;
        return <div className="form-row">
            <div className="alert alert-info">
                {t('analytics_component.not_access_message')}
            </div>
        </div>
    }

    renderTestButton() {
        const { t } = this.props;
        if(this.state.testing === true) {
            return <SpinnerSecondaryButton style={{minWidth:"115px"}} className="btn btn-secondary"/>;
        }

        return <Button key="button" className="btn btn-secondary" onClick={this.handleTest}  style={{minWidth:"115px"}}>{t('analytics_component.test_button')}</Button>
    }

    renderInnerComponents() {
        const { t } = this.props;
        if (this.state.hasAccessToModule && this.state.loading === true) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        const elements = [];
        elements.push(<div className="form-row">
            <label>{t('analytics_component.description')}<br/>En este artículo puedes ver el paso a paso&nbsp;&nbsp;➡️<LinkToArticle article={HELP_GA4_THOU_SHEETS}/></label>
        </div>);

        if(!this.state.hasAccessToModule) {
            elements.push(this.renderNotAccessStatus());
            return elements;
        }

        elements.push(this.renderAnalyticsComponents());
        elements.push(this.renderSaveButton());
        return elements;
    }

    renderAnalyticsComponents() {
        const { t } = this.props;
        return <div className="form-row">
            <div className="form-col col-12 mb-3">
                <label>{t('analytics_component.csv_url_label')}</label>
                <div className="input-group-append">
                    <Input name="analyticsUrl" readOnly={false} type="text" value={this.state.analyticsUrl}
                           onChange={this.handleAnalyticsChange} className="form-control mr-2"/>
                    {this.renderTestButton()}
                </div>
            </div>
        </div>
    }
}

export const AnalyticsComponent = withTranslation()(AnalyticsComponentClass);
export default AnalyticsComponent;
